import React from 'react';
import { Controller } from 'react-hook-form';

import { image } from 'src/theme';
import { DatePicker } from '@mui/x-date-pickers';
import { RegularText } from '../text';
import styled from '@emotion/styled';
import { RequiredMark } from '@/components/input/InputBasic';
import { FormControl, FormHelperText } from '@mui/material';
import { mq } from '@/utils/mediaQuery';

const StyledSelectInputContainer = styled.div(() => ({
  minHeight: '8rem',
  width: '100%',
}));

const StyledDatePicker = styled(DatePicker)(() => ({
  maxHeight: '5.6rem',

  [mq('desktop')]: {
    fontSize: '1.6rem',
  },
}));

const InputDate = ({ control, name, label, required, errors }) => {
  return (
    <StyledSelectInputContainer>
      <Controller
        name={name}
        control={control}
        render={({ field }) => {
          return (
            <FormControl error={!!errors[name]}>
              <StyledDatePicker
                {...field}
                value={field.value !== '' ? field.value : null}
                label={
                  <>
                    <RegularText id={label} fontSize="1.6rem" />
                    {required && <RequiredMark>*</RequiredMark>}
                  </>
                }
                format="YYYY-MM-DD"
                disablePast
                onChange={(val) => {
                  if (val !== null) {
                    field.onChange(val);
                  }
                }}
                slots={{
                  openPickerIcon: () => (
                    <img src={image.datepickerIcon.default} alt="picker icon" width={24} />
                  ),
                }}
                slotProps={{
                  textField: {
                    error: !!errors[name],
                  },
                  openPickerButton: {
                    sx: {
                      padding: '1rem',
                      right: 1,
                    },
                  },
                }}
              />

              {errors[name] && <FormHelperText>{errors[name].message}</FormHelperText>}
            </FormControl>
          );
        }}
      />
    </StyledSelectInputContainer>
  );
};

export default InputDate;
